import Coupon from '@alltrails/core/types/Coupon';
import Plan from '@alltrails/core/types/Plan';
import type CurrencyCode from '@alltrails/core/types/CurrencyCode';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const getFreeTrialDurationPricing = (plan: Plan, currencyCode: CurrencyCode, coupon: Coupon) => {
  const couponTrialDuration = coupon.freeTrialDuration;
  if (couponTrialDuration) {
    const durationData = couponTrialDuration.split(' ');
    const durationNum = Number(durationData[0]);
    const durationType = durationData[1];

    if (durationType.includes('month')) {
      if (durationNum === 1) {
        return (
          <FormattedMessage
            defaultMessage="1 month free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
            }}
          />
        );
      }

      if (durationNum > 1) {
        return (
          <FormattedMessage
            defaultMessage="{durationNum} months free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />,
              durationNum
            }}
          />
        );
      }
    }

    if (durationType.includes('week')) {
      if (durationNum === 1) {
        return (
          <FormattedMessage
            defaultMessage="1 week free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
            }}
          />
        );
      }

      if (durationNum > 1) {
        return (
          <FormattedMessage
            defaultMessage="{durationNum} weeks free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />,
              durationNum
            }}
          />
        );
      }
    }

    if (durationType.includes('day')) {
      if (durationNum === 1) {
        return (
          <FormattedMessage
            defaultMessage="1 day free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
            }}
          />
        );
      }

      if (durationNum > 1) {
        return (
          <FormattedMessage
            defaultMessage="{durationNum} days free, then {annualCost}/year (that’s {monthlyCost}/month)"
            values={{
              annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
              monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />,
              durationNum
            }}
          />
        );
      }
    }
  }

  return (
    <FormattedMessage
      defaultMessage="{annualCost}/year (that’s {monthlyCost}/month)"
      values={{
        annualCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceTotal} />,
        monthlyCost: <FormattedNumber currency={currencyCode} style="currency" value={plan.priceMonth} />
      }}
    />
  );
};

export default getFreeTrialDurationPricing;
